import { render, staticRenderFns } from "./informationData.vue?vue&type=template&id=40a011ba&scoped=true"
import script from "./informationData.vue?vue&type=script&lang=js"
export * from "./informationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a011ba",
  null
  
)

export default component.exports